var _defs, _polygon, _polygon2, _polygon3, _rect, _path, _polygon4, _polygon5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLyniate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.02 33.05 33.02 67.02 56.52 67.02 56.52 62.09 38.45 62.09 38.45 33.05 33.02 33.05"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.49 33.05 75.77 46.77 66.05 33.05 59.82 33.05 73 51.62 73 67.02 78.35 67.02 78.35 51.47 91.53 33.05 85.49 33.05"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "126.54 33.05 126.54 57.61 107.29 33.05 102.62 33.05 102.62 67.02 107.89 67.02 107.89 42.3 127.26 67.02 131.78 67.02 131.78 33.05 126.54 33.05"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 146.54,
    y: 33.13,
    width: 5.35,
    height: 33.97
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M178.36,32.9,163.48,67.1h5.69l3.65-8.42H189l3.68,8.42h5.74L183.52,32.9Zm2.54,6.75,6.23,14.26H174.68Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "202.32 33.13 202.32 37.98 213.56 37.98 213.56 67.1 218.91 67.1 218.91 37.98 230.19 37.98 230.19 33.13 202.32 33.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "242.11 33.13 242.11 67.1 266.98 67.1 266.98 62.17 247.47 62.17 247.47 51.4 262.85 51.4 262.85 46.47 247.47 46.47 247.47 37.98 266.38 37.98 266.38 33.13 242.11 33.13"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyniate);
export default __webpack_public_path__ + "static/media/lyniate.e528c02905d204da46bd70766723ade3.svg";
export { ForwardRef as ReactComponent };